import { Component, inject } from '@angular/core';
import { ReturnWarrantyComponent, SelectedCustomerService } from 'gung-standard';
import { TyloOrderServicesService } from '../../services/tylo-order-services.service';

@Component({
  selector: 'tylo-return-warranty',
  templateUrl: './tylo-return-warranty.component.html',
  styleUrl: './tylo-return-warranty.component.css',
  standalone: false
})
export class TyloReturnWarrantyComponent extends ReturnWarrantyComponent {
  protected selectedCustomerService : SelectedCustomerService = inject(SelectedCustomerService);
  protected orderServicesService : TyloOrderServicesService = inject(TyloOrderServicesService);

  protected customerHasReachedDailyLimit: boolean = false;
  private selectedCustomerId?: string;

  ngOnInit(): void {
    this.selectedCustomerService.getSelectedCustomer().subscribe(customer => {
      if (customer?.id) {
        this.selectedCustomerId = customer.id;
        this.checkDailyLimit(customer.id);
      }
    });
  }

  override openCreateModal() {
    this.gungModalService.openViewCreateReturnWarrantyModal().then(
      result => {
        if (result && this.selectedCustomerId) {
          this.checkDailyLimit(this.selectedCustomerId);
        }
      },
      reason => {}
    );
  }

  private checkDailyLimit(customerId: string): void {
    this.orderServicesService.findNumberOfOrderServicesTicketsForCustomer(customerId).subscribe(number => {
      if (number >= 3) {
        this.customerHasReachedDailyLimit = true;
      }
    });
  }
}
